import { render, staticRenderFns } from "./LoadBar.vue?vue&type=template&id=6bff6854&scoped=true&"
import script from "./LoadBar.vue?vue&type=script&lang=ts&"
export * from "./LoadBar.vue?vue&type=script&lang=ts&"
import style0 from "./LoadBar.vue?vue&type=style&index=0&id=6bff6854&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff6854",
  null
  
)

export default component.exports